var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"commandAreaListWrap"},_vm._l((_vm.listData),function(v,i){return _c('li',{key:i,on:{"click":function($event){return _vm.changeBtn(v,i)}}},[_c('img',{attrs:{"src":require(`@/assets/images/msgt/area/${_vm.activeItme==i?('a'+v.key):v.key}.png`)}}),_c('p',[_vm._v(_vm._s(v.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }